import React from 'react';

import { message, PageHeader } from 'antd';
import { useHistory, useLocation } from 'react-router-dom';
import { T } from 'react-translator-component';

import * as S from './styled';

import { createCompany } from '../../../hooks/company';
import CompanyForm from '../../organisms/CompanyForm/CompanyForm';

const CompanyCreatePage = () => {
  const history = useHistory();
  const location: any = useLocation();

  const handleNavigateBack = () => {
    if (location.state?.isFrom === 'create') {
      history.replace('/vehicle/create', {
        plate: location.state.plate,
        isVehicle: true,
      });
    } else {
      history.replace(`/vehicle/${location.state.id}/edit`, {
        plate: location.state.plate,
        isVehicle: true,
      });
    }
  };
  const handleCreateCompany = async (values: any) => {
    try {
      const response = await createCompany({
        name: values.name,
        nit: values.nit,
        sap_code: values.sapCode,
      });

      if (response.status === 200) {
        handleNavigateBack();
      }
    } catch {
      message.error(T('Failed to create company.'));
    }
  };

  return (
    <>
      <S.Wrapper>
        <PageHeader
          onBack={() => handleNavigateBack()}
          title={<>{T('Creating company')}</>}
        />

        <S.Blank>
          <CompanyForm
            initialValues={{
              name: '',
              nit: '',
              sapCode: '',
            }}
            loading={false}
            isEdit={false}
            onSubmit={handleCreateCompany}
          />
        </S.Blank>
      </S.Wrapper>
    </>
  );
};

export default CompanyCreatePage;
